
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
  @Component
export default class CourseOccupy extends Vue {
    @Prop() dialogAddZy: boolean
    @Prop() title: string
    @Prop() remark: string
    
    addOccupy: any = {
      desc: ''
    }
    @Watch('dialogAddZy')
    getDesc(val){
      this.addOccupy.desc = this.remark
    }
    // 添加占用弹窗关闭
    handleAddZyClose() {
      this.addOccupy.type = 'close'
      this.$emit('occupy-close', this.addOccupy)
    }
    // 添加占用弹窗确定
    handleAddZyTrue() {
      if (this.addOccupy.desc == '') {
        return false
      }
      this.addOccupy.type = 'true'
      this.$emit('occupy-close', this.addOccupy)
    }
}
